import React from 'react';
import { useMutation } from '@apollo/client';
import AddUserMealToTrackerMutation from './AddUserMealToTrackerMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ITrackerAddMealConnectorApolloProps {
  children: ({ addUserMeal }: { addUserMeal: (input: any) => Promise<any> }) => React.ReactElement;
  post: any;
}

const TrackerAddMealConnectorApollo: React.FC<ITrackerAddMealConnectorApolloProps> = ({
  children,
  post,
}) => {
  const [addUserMealMutation] = useMutation(AddUserMealToTrackerMutation);

  const addUserMeal = async (input: any) => {
    const date = formatIsoDate(new Date(input.dateTime));

    const response = await addUserMealMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TrackerQuery,
          variables: {
            date,
          },
        },
      ],
    });

    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.addUserMeal;
  };
  return children({ addUserMeal });
};

export default TrackerAddMealConnectorApollo;
